// Implements: F-VER-004, F-VER-010, F-VER-016
/**
 * The three files of a version (prototype HTML, zipped export, diagram package), downloaded through
 * the client. Moved here from `modules/versions/api/versionsApi.ts` (mockup v3 P4), which still
 * re-exports them, so the `mockups` module can export a version without importing `versions`.
 */

import type { VersionDownload } from "../../types/api";
import { API_BASE } from "./apiBase";
import { httpDownload } from "./httpClient";
import type { Download } from "./httpClient";

export type { VersionDownload } from "../../types/api";

const DOWNLOAD_FILES: Readonly<Record<VersionDownload, string>> = {
  html: "export.html",
  zip: "export.zip",
  diagram: "diagram.zip",
};

function versionPath(mockupId: string, versionId: string): string {
  return `${API_BASE}/mockups/${encodeURIComponent(mockupId)}/versions/${encodeURIComponent(versionId)}`;
}

/**
 * Download one of the three files of a version through the client.
 *
 * The routes answer a file with `Content-Disposition: attachment`; going
 * through the client (and not a bare link) is what turns a 403 or a 404 into
 * an error the page can show, instead of an error body saved as the file.
 * A `GET` is idempotent, so the client's retry of a 5xx applies.
 */
export async function downloadVersionFile(
  mockupId: string,
  versionId: string,
  kind: VersionDownload,
): Promise<Download> {
  return httpDownload(`${versionPath(mockupId, versionId)}/${DOWNLOAD_FILES[kind]}`);
}

const DEFAULT_NAMES: Readonly<Record<VersionDownload, (n: number) => string>> = {
  html: (n) => `prototipo-v${String(n)}.html`,
  zip: (n) => `prototipo-v${String(n)}.zip`,
  diagram: (n) => `diagrama-v${String(n)}.zip`,
};

/** The name the backend gives each file, for the answer that carries none. */
export function defaultDownloadName(kind: VersionDownload, sequenceNumber: number): string {
  return DEFAULT_NAMES[kind](sequenceNumber);
}
